import createReducer from './createReducer';
import plain from './structure/plain';
export default createReducer(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/reducer.js
// module id = O0mW
// module chunks = 1